;(function () {
  angular
    .module('contrast.server.vulnerabilities')
    .factory('serverVulnsApiConfig', serverVulnsApiConfigFactory)

  function serverVulnsApiConfigFactory($http, UserService) {
    'ngInject'

    return {
      getVulnerability: function (serverId, traceUuid, expandValue) {
        return $http.get(
          UserService.buildAPIUrl(
            '/servertraces/' + serverId + '/filter/' + traceUuid
          ),
          { params: { expand: expandValue } }
        )
      },
      getVulnerabilityShort: function (serverId, traceUuid, expandValue) {
        return $http.get(
          UserService.buildAPIUrl(
            '/servertraces/' + serverId + '/' + traceUuid + '/short'
          ),
          { params: { expand: expandValue } }
        )
      },

      getVulnerabilityVisibility: function (serverId, traceUuid) {
        return $http.get(
          UserService.buildAPIUrl(
            '/servertraces/' + serverId + '/' + traceUuid + '/visible'
          )
        )
      },

      markStatus: function (serverId, data) {
        return $http.put(
          UserService.buildAPIUrl('/servertraces/' + serverId + '/mark'),
          data
        )
      },
      shareViaEmail: function (serverId, data) {
        return $http.post(
          UserService.buildAPIUrl('/servertraces/' + serverId + '/share/email'),
          data
        )
      },
      deleteTraces: function (serverId, data) {
        return $http['delete'](
          UserService.buildAPIUrl('/servertraces/' + serverId),
          {
            data: data,
            headers: { 'Content-Type': 'application/json' }
          }
        )
      },

      getRemediationPolicyViolations: function (serverId) {
        return $http.get(
          UserService.buildAPIUrl(
            '/servertraces/' + serverId + '/policy/violations'
          )
        )
      },

      updateSeverity: function (serverId, traceUuid, data) {
        return $http.put(
          UserService.buildAPIUrl(
            '/servertraces/' + serverId + '/trace/' + traceUuid + '/severity'
          ),
          data
        )
      }
    }
  }
})()
